(function() {
  var ZOOM_LEVEL = 1.4;

  function getHiResSrc(img) {
    // Get the highest resolution src available
    var srcset = img.getAttribute('srcset');
    if (srcset) {
      var sources = srcset.split(',').map(function(s) { return s.trim(); });
      var last = sources[sources.length - 1];
      return last.split(' ')[0];
    }
    return img.currentSrc || img.src;
  }

  function initMagnifier() {
    document.querySelectorAll('modal-opener.product__modal-opener').forEach(function(opener) {
      if (opener.dataset.magnifierInit) return;
      opener.dataset.magnifierInit = 'true';

      var img = opener.querySelector('img');
      if (!img) return;

      var mediaDiv = opener.querySelector('.product__media');
      if (!mediaDiv) return;

      // Block modal from opening
      opener.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }, true);

      var button = opener.querySelector('.product__media-toggle');
      if (button) {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }, true);
      }

      // Create zoom overlay that sits on top of the image
      var overlay = document.createElement('div');
      overlay.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;z-index:10;background-repeat:no-repeat;opacity:0;transition:opacity 0.3s ease;cursor:zoom-in;pointer-events:auto;';
      mediaDiv.style.position = 'relative';
      mediaDiv.appendChild(overlay);

      overlay.addEventListener('mouseenter', function() {
        var src = getHiResSrc(img);
        overlay.style.backgroundImage = 'url(' + src + ')';
        overlay.style.backgroundSize = (ZOOM_LEVEL * 100) + '% ' + (ZOOM_LEVEL * 100) + '%';
        overlay.style.opacity = '1';
        overlay.style.cursor = 'zoom-out';
      });

      overlay.addEventListener('mousemove', function(e) {
        var rect = overlay.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        overlay.style.backgroundPosition = x + '% ' + y + '%';
      });

      overlay.addEventListener('mouseleave', function() {
        overlay.style.opacity = '0';
        overlay.style.cursor = 'zoom-in';
      });
    });
  }

  function waitForImages() {
    var images = document.querySelectorAll('modal-opener.product__modal-opener img');
    if (images.length === 0) {
      setTimeout(waitForImages, 300);
      return;
    }
    initMagnifier();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(waitForImages, 500); });
  } else {
    setTimeout(waitForImages, 500);
  }

  // Re-init on variant change
  document.addEventListener('variant:changed', function() {
    document.querySelectorAll('[data-magnifier-init]').forEach(function(el) {
      var overlay = el.querySelector('.product__media div[style*="z-index:10"]');
      if (overlay) overlay.remove();
      delete el.dataset.magnifierInit;
    });
    setTimeout(initMagnifier, 400);
  });
})();
